import { defineStore } from 'pinia'
import { createStorage } from '@/utils/storageUtils'
import { store } from '@/stores'
import { ACCESS_TOKEN, CURRENT_USER } from '@/stores/mutation-types'
import { getUserInfo, login, doLogout } from '@/api/system/user'
import { ResultEnum } from '@/enums/httpEnum'
import { PageEnum } from '@/enums/pageEnum'
import router from '@/router'

const Storage = createStorage({ storage: localStorage })

export const useUserStore = defineStore({
  id: 'app-user',
  state: () => ({
    userInfo: null,
    token: undefined,
    lastUpdateTime: 0
  }),
  getters: {
    getUserInfo() {
      return this.userInfo || Storage.get(CURRENT_USER, '') || {}
    },
    getToken() {
      return this.token || Storage.get(ACCESS_TOKEN, '')
    },
    getLastUpdateTime() {
      return this.lastUpdateTime
    }
  },
  actions: {
    setToken(token) {
      this.token = token ? token : ''
      Storage.set(ACCESS_TOKEN, token)
    },
    setUserInfo(info) {
      this.userInfo = info
      this.lastUpdateTime = new Date().getTime()
      Storage.set(CURRENT_USER, info)
    },

    async Login(params) {
      try {
        const response = await login(params)
        const { result, code } = response
        if (code === ResultEnum.SUCCESS) {
          // save token
          this.setToken(result.token)
        }
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },

    async GetUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            this.setUserInfo(res)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    async Logout() {
      if (this.getToken) {
        try {
          await doLogout()
        } catch {
          console.error('注销Token失败')
        }
      }
      this.setToken(undefined)
      this.setUserInfo(null)
      Storage.remove(ACCESS_TOKEN)
      Storage.remove(CURRENT_USER)
      router.push(PageEnum.BASE_LOGIN)
      location.reload()
    }
  }
})

export function useUserStoreWidthOut() {
  return useUserStore(store)
}
